var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8318 16.9453L20.9997 15.6972V11C20.9997 9.86397 20.6568 8.35717 19.8865 7.07955C18.7214 5.14722 16.7635 4 13.9997 4C11.2359 4 9.27808 5.14722 8.11298 7.07955C7.34264 8.35717 6.99973 9.86397 6.99973 11V15.6972L5.16768 18.4453C4.72464 19.1099 5.20103 20 5.99973 20H21.9997C22.7984 20 23.2748 19.1099 22.8318 18.4453L21.8318 16.9453ZM19.1677 16.5547L20.1312 18H7.86825L8.83178 16.5547C8.94129 16.3904 8.99973 16.1974 8.99973 16V11C8.99973 10.2018 9.26278 9.04591 9.82573 8.11225C10.6349 6.77019 11.9493 6 13.9997 6C16.0501 6 17.3645 6.77019 18.1737 8.11225C18.7367 9.04591 18.9997 10.2018 18.9997 11V16C18.9997 16.1974 19.0582 16.3904 19.1677 16.5547ZM12.9997 21C12.4474 21 11.9997 21.4477 11.9997 22C11.9997 22.5523 12.4474 23 12.9997 23H14.9997C15.552 23 15.9997 22.5523 15.9997 22C15.9997 21.4477 15.552 21 14.9997 21H12.9997Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.23a10b32bdf8916fda5847d9232a8890.svg";
export { ForwardRef as ReactComponent };